// Knowledge Graph Mock Data Index
import { quadraticSamples } from './quadraticSamples.js';
import { circleGeometrySamples } from './circleGeometrySamples.js';
import { factorRemainderSamples } from './factorRemainderSamples.js';
import { probabilitySamples } from './probabilitySamples.js';
import { statisticsSamples } from './statisticsSamples.js';
import { trigonometrySamples } from './trigonometrySamples.js';
import { numberSystemSamples } from './numberSystemSamples.js';
import { identitiesSamples } from './identitiesSamples.js';
import { simultaneousEquationsSamples } from './simultaneousEquationsSamples.js';
import { geometrySamples } from './geometrySamples.js';
import { locusSamples } from './locusSamples.js';
import { percentagesSamples } from './percentagesSamples.js';
import { transformationSymmetrySamples } from './transformationSymmetrySamples.js';
import { exponentialLogarithmSamples } from './exponentialLogarithmSamples.js';
import { inequalitiesLinearProgrammingSamples } from './inequalitiesLinearProgrammingSamples.js';
import { ratesRatiosVariationsSamples } from './ratesRatiosVariationsSamples.js';
import { arithmeticGeometricSequencesSamples } from './arithmeticGeometricSequencesSamples.js';
import { mensurationSamples } from './mensurationSamples.js';
import { trigonometry2D3DSamples } from './trigonometry2D3DSamples.js';
import { straightLineEquationsSamples } from './straightLineEquationsSamples.js';

// HKDSE Paper 1 Samples
import { allHkdseSamples, hkdse2021Samples_combined, hkdse2022Samples_combined, hkdse2023Samples_combined, hkdse2024Samples_combined, hkdse2025Samples_combined, hkdse2020Samples, hkdse2019Samples, hkdse2018Samples, hkdse2017Samples, hkdse2016Samples, hkdse2015Samples } from './HKDSE_Paper1/index.js';

// Re-export all samples
export { 
  quadraticSamples, 
  circleGeometrySamples, 
  factorRemainderSamples, 
  probabilitySamples, 
  statisticsSamples, 
  trigonometrySamples,
  numberSystemSamples,
  identitiesSamples,
  simultaneousEquationsSamples,
  geometrySamples,
  locusSamples,
  percentagesSamples,
  transformationSymmetrySamples,
  exponentialLogarithmSamples,
  inequalitiesLinearProgrammingSamples,
  ratesRatiosVariationsSamples,
  arithmeticGeometricSequencesSamples,
  mensurationSamples,
  trigonometry2D3DSamples,
  straightLineEquationsSamples,
  allHkdseSamples,
  hkdse2021Samples_combined,
  hkdse2022Samples_combined,
  hkdse2023Samples_combined,
  hkdse2024Samples_combined,
  hkdse2025Samples_combined,
  hkdse2020Samples,
  hkdse2019Samples,
  hkdse2018Samples,
  hkdse2017Samples,
  hkdse2016Samples,
  hkdse2015Samples
};

// All samples combined
export const allSamples = {
  quadratic: quadraticSamples,
  circleGeometry: circleGeometrySamples,
  factorRemainder: factorRemainderSamples,
  probability: probabilitySamples,
  statistics: statisticsSamples,
  trigonometry: trigonometrySamples,
  numberSystem: numberSystemSamples,
  identities: identitiesSamples,
  simultaneousEquations: simultaneousEquationsSamples,
  geometry: geometrySamples,
  locus: locusSamples,
  percentages: percentagesSamples,
  transformationSymmetry: transformationSymmetrySamples,
  exponentialLogarithm: exponentialLogarithmSamples,
  inequalitiesLinearProgramming: inequalitiesLinearProgrammingSamples,
  ratesRatiosVariations: ratesRatiosVariationsSamples,
  arithmeticGeometricSequences: arithmeticGeometricSequencesSamples,
  mensuration: mensurationSamples,
  trigonometry2D3D: trigonometry2D3DSamples,
  straightLineEquations: straightLineEquationsSamples,
  hkdse: {
    // 2021 samples (existing structure - flattened)
    ...allHkdseSamples,
    // Year-specific samples (organized by year)
    hkdse2021: hkdse2021Samples_combined,
    hkdse2022: hkdse2022Samples_combined,
    hkdse2023: hkdse2023Samples_combined,
    hkdse2024: hkdse2024Samples_combined,
    hkdse2025: hkdse2025Samples_combined,
    hkdse2020: hkdse2020Samples,
    hkdse2019: hkdse2019Samples,
    hkdse2018: hkdse2018Samples,
    hkdse2017: hkdse2017Samples,
    hkdse2016: hkdse2016Samples,
    hkdse2015: hkdse2015Samples
  }
};

// Legacy support - maintain backward compatibility
export const allMockData = allSamples; 